import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { portalHref } from "@/features/portal/portal-base";

/**
 * Generic portal entry (the portal root) — shown when we don't know the firm
 * handle. The taxpayer normally arrives via their firm's branded link
 * (`portal.<host>/<handle>`); this lets them type the handle to get there.
 */
export default function PortalLandingPage() {
  const [handle, setHandle] = useState("");
  const navigate = useNavigate();

  return (
    <div className="mx-auto max-w-md py-10">
      <Card>
        <CardHeader>
          <CardTitle>Client Portal</CardTitle>
        </CardHeader>
        <CardContent>
          <form
            className="grid gap-4"
            onSubmit={(e) => {
              e.preventDefault();
              const h = handle.trim();
              if (h) navigate(portalHref(`/${encodeURIComponent(h)}`));
            }}
          >
            <div className="grid gap-2">
              <Label htmlFor="handle">Your firm's portal name</Label>
              <Input
                id="handle"
                value={handle}
                onChange={(e) => setHandle(e.target.value)}
                placeholder="e.g. acme"
                autoFocus
              />
              <p className="text-muted-foreground text-sm">
                Use the link your tax professional sent you, or enter your firm's
                portal name above.
              </p>
            </div>
            <Button type="submit" disabled={!handle.trim()}>
              Continue
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
